import {
  AutocompleteResponse,
  AutocompleteSuggestion,
  queryAssistanceClient,
} from '@dynatrace-sdk/client-query';

export type SuggestionCache = Map<
  string,
  { suggestions: AutocompleteSuggestion[]; ttl?: number }
>;

const globalCache: SuggestionCache = new Map();

/** Gets memoized suggestions. */
export const getSuggestions: (
  query: string,
  cursor?: number,
  maxDataSuggestions?: number,
  cache?: SuggestionCache,
) => Promise<AutocompleteSuggestion[]> = async (
  query,
  _cursor,
  maxDataSuggestions,
  cache = globalCache,
) => {
  const cursor = _cursor ?? query.length;
  const key = JSON.stringify({ query, cursor });
  const currentTime = new Date().getTime();

  const cacheHit = cache.get(key);
  if (cacheHit && (cacheHit.ttl ? cacheHit.ttl > currentTime : true)) {
    return cacheHit.suggestions;
  } else {
    cache.delete(key);

    const { suggestions, suggestedTtlSeconds } =
      await getSuggestionsFromQueryEndpoint(query, cursor, maxDataSuggestions);

    cache.set(key, {
      suggestions: suggestions ?? [],
      ttl:
        suggestedTtlSeconds !== undefined
          ? new Date().getTime() + suggestedTtlSeconds * 1000
          : undefined,
    });

    return suggestions;
  }
};

/** Gets suggestions from autocomplete endpoint. */
async function getSuggestionsFromQueryEndpoint(
  query: string,
  cursor: number,
  maxDataSuggestions: number = 1_000,
): Promise<AutocompleteResponse> {
  try {
    return await queryAssistanceClient.queryAutocomplete({
      body: { query, cursorPosition: cursor, maxDataSuggestions },
    });
  } catch {
    //nothing
  }
  return { suggestions: [], suggestedTtlSeconds: undefined, optional: false };
}
